import {
  ACTIVO_METODOS_PAGO,
  CLEAR_ALL,
  GETALL_METODOS_PAGO,
  LOADING_GETALL_METODOS_PAGO,
  PARAMS_METODOS_PAGO,
  SET_LOGOUT,
} from '../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  activo: null,
  params: {},
};

export const metodosPagoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_METODOS_PAGO:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_METODOS_PAGO:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_METODOS_PAGO:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_METODOS_PAGO:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
